import { Component, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import {
  MerchantAccountActions,
  MerchantAccountSelectors,
} from '@app/merchant-account/store/merchant-account.slice';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnInit {
  isTableLoading$: Observable<boolean> = this.store.select(
    MerchantAccountSelectors.selectIsTableLoading
  );
  merchantAdmins$ = this.store.select(
    MerchantAccountSelectors.selectMerchantAdmins
  );

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.store.dispatch(MerchantAccountActions.getMerchantAdmins.trigger());
  }
}
